import React from 'react';
import { useTranslation } from 'react-i18next';

import type { RadarSeverity } from '../../../types/radar';

import './_severity-indicator.scss';

type SeverityIndicatorProps = {
  severity: RadarSeverity;
};

function SeverityIndicator({ severity }: SeverityIndicatorProps): JSX.Element {
  const { t } = useTranslation(['chatbot']);

  const barCount = severity === 'high' ? 3 : severity === 'medium' ? 2 : 1;

  const labelKey =
    severity === 'high' ? 'radar_severity_high' : severity === 'medium' ? 'radar_severity_medium' : 'radar_severity_low';

  return (
    <div className={`severity-indicator severity-indicator--${severity}`} title={t(labelKey)}>
      {[1, 2, 3].map((index) => (
        <span
          key={index}
          className={`severity-indicator__bar ${index <= barCount ? 'severity-indicator__bar--active' : ''}`}
        />
      ))}
    </div>
  );
}

export default SeverityIndicator;
